import sessionStore from './modules/session';
import environment from './modules/environment';

export default {
  sessionStore,
  environment,
};



// WEBPACK FOOTER //
// ./src/store/index.js